import React, { FC, ReactElement } from 'react'
import { Option } from '../Option/Option'
import { IOrganizationsItem } from '../../../interfaces/IOrganizationsItem'
import style from './OrganizationOption.module.css'

type OrganizationOptionProps = {
  isActive: boolean
  option: IOrganizationsItem
}

export const OrganizationOption: FC<OrganizationOptionProps> = ({ isActive, option }): ReactElement => (
  <Option isActive={isActive}>
    <div>
      {option.name}
      <div className={style.description}>{option.inn}</div>
    </div>
  </Option>
)

OrganizationOption.displayName = 'OrganizationOption'
